<!--
 * @Author: wzh
 * @LastEditTime: 2024-10-14 12:02:57
 * @Description: 登录
-->
<template>
  <div class="login_main">
    <div class="l_top">
      <!-- <div class="l_t_select">
        <Popover placement="bottom-end" v-model="showPopover" trigger="click" :actions="actions"
          @select="languageChange">
          <template #reference>
            <span>{{ language }}
              <Icon name="arrow-down" />
            </span>
          </template>
        </Popover>
      </div> -->
      <div class="l_t_banner">
        <img v-if="logoBase64" :src="logoBase64" />
      </div>
      <div class="l_t_title">{{ $t("login.title") }}</div>
    </div>

    <div class="l_m_body">
      <div class="l_m_title">{{ $t("webapp.login.welcome") }}</div>

      <div class="l_m_form">
        <Form @submit="onSubmit">
          <Field
            v-model="form.username"
            :placeholder="$t('login.username_placeholder')"
            :rules="[{ required: true }]"
            class="l_m_username"
            @keyup.enter.native.stop="onSubmit"
          />
          <Field
            v-model="form.password"
            :placeholder="$t('login.password_placeholder')"
            :rules="[{ required: true }]"
            type="password"
            class="l_m_password"
            @keyup.enter.native.stop="onSubmit"
          />
          <template
            v-if="
              (loginSetInfo.yzfs == 1 || loginSetInfo.yzfs == 3) &&
              loginFailCount >= loginSetInfo.yzmcxsj
            "
          >
            <Field
              :rules="[{ required: true }]"
              v-model="form.captcha"
              :placeholder="$t('base.captcha.placeholder')"
              class="l_m_code_box"
              @keyup.enter.native.stop="onSubmit"
            >
              <template #button>
                <img
                  class="l_m_code"
                  :src="validMaskImage"
                  alt=""
                  @click="getValidMask"
                />
              </template>
            </Field>
          </template>
          <div class="l_m_forget">
            <span @click="handleForget">{{ $t("base.password.tip") }}</span>
            <span v-if="basicSetInfo.zhjh == 1" @click="handleActivate">{{
              $t("login.account_activation")
            }}</span>
          </div>
          <div v-if="loginSetInfo.qtmdl == 1" class="l_m_remember">
            <Checkbox v-model="remeberMe" shape="square">{{
              $t("login.no_login")
            }}</Checkbox>
          </div>

          <Button
            type="info"
            block
            round
            native-type="submit"
            :loading="loginLoading"
            >{{ $t("login.login_btn") }}</Button
          >
        </Form>
      </div>

      <!-- <Divider>第三方账号登录</Divider>

      <div class="l_m_other">
        <img src="@/assets/mAssets/images/login/icon_wx.png" />
        <img src="@/assets/mAssets/images/login/icon_wx2.png" />
        <img src="@/assets/mAssets/images/login/icon_dd.png" />
        <img src="@/assets/mAssets/images/login/icon_google.png" />
        <img src="@/assets/mAssets/images/login/icon_wr.png" />
      </div>

      <div class="l_m_more"><span @click="handleMore">更多登录>></span></div> -->
    </div>

    <!-- 滑块验证 -->
    <self-verify
      v-if="verifyVisible"
      @success="slideSuccess"
      @close="slideClose"
    ></self-verify>
  </div>
</template>

<script>
import { Popover, Icon, Form, Field, Button, Divider, Checkbox } from "vant";
import { commonAPI } from "@/apis";
import { toast } from "@/utils/toast";
import { currentLanguage } from "@/utils/helpers";
// 滑块
import SelfVerify from "./SelfVerify";
import { commonMethods } from "../loginAuth/mixins/common";
import { loginErrorText } from "@/constants/loginError";
import { encryptAES } from "@/utils";

export default {
  name: "Login",
  components: { Popover, Icon, Form, Field, Button, Divider, Checkbox, SelfVerify },
  mixins: [commonMethods],
  data() {
    return {
      language: "简体中文",
      showPopover: false,
      actions: [
        { text: "简体中文", value: "zh" },
        { text: "English", value: "en" },
      ],
      form: {},
      verifyVisible: false, // 拼图弹窗
      loginFailCount: 0, // 登录失败次数
      validMaskImage: "", // 验证码图片
      stateToken: "", // 验证码返回的state 临时token
      basicSetInfo: {}, // 基础配置信息
      loginSetInfo: {}, // 登录配置信息
      loginLoading: false,
      logoBase64: "", // logo
      remeberMe: false, // 7 天免登录（与 PC 端一致，需后台登录配置 qtmdl=1）
    };
  },

  created() {
    this.language = currentLanguage(true).text;
    this.getValidMask();
    this.getBasicSet();
    this.getLoginSet();
    this.getSafeSet();
    this.getBqLogo();
  },
  methods: {
    // 获取登录配置
    async getLoginSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/login/get"
      );
      if (code == 0) {
        let obj = { ...data };
        this.loginSetInfo = obj;
        sessionStorage.setItem("LOGIN_SET_INFO", JSON.stringify(obj));
      } else {
        toast(message);
      }
    },
    // 获取基础配置
    async getBasicSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/basic/get"
      );
      if (code == 0) {
        let obj = { ...data };
        this.basicSetInfo = obj;
        sessionStorage.setItem("BASIC_SET_INFO", JSON.stringify(obj));
      } else {
        toast(message);
      }
    },
    // 获取安全配置
    async getSafeSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/safe/get"
      );
      if (code == 0) {
        let obj = { ...data };
        sessionStorage.setItem("SAFE_SET_INFO", JSON.stringify(obj));
      } else {
        toast(message);
      }
    },
    // 得到验证码图片
    async getValidMask() {
      const { code, data } = await commonAPI.getAction("/captcha");
      if (code === 0) {
        this.validMaskImage = data.image;
        this.stateToken = data.state;
      }
    },
    // 获取版权、logo
    async getBqLogo() {
      const { code, data } = await commonAPI.getAction("/setting/logo/get");
      if (code == 0) {
        // this.copyrightInfo = data.copyRight || "";
        this.logoBase64 = data.logoFileBase64 || "";
      }
    },
    // 表单提交
    onSubmit(values) {
      if (
        this.loginSetInfo.yzfs == 2 &&
        this.loginFailCount >= this.loginSetInfo.yzmcxsj
      ) {
        this.verifyVisible = true;
      } else {
        this.handleLogin();
      }
    },
    // 登录
    async handleLogin() {
      const that = this;
      let redirect_uri = this.$route.query.redirect_uri;
      this.loginLoading = true;
      const data1 = { ...this.form };
      data1.password = encryptAES(data1.password, null);
      const params = {
        ...data1,
        authType: "normal",
        state: this.stateToken,
        remeberMe: this.remeberMe ? "1" : "0",
        serviceUrl: redirect_uri ? this.getBase64(redirect_uri) : "",
      };
      const { code, data, message } = await commonAPI.postAction(
        "/login/signin",
        params
      );
      this.loginLoading = false;
      if (code == 0) {
        // 登录成功
        if (redirect_uri) {
          sessionStorage.setItem("REDIRECT_URI", redirect_uri);
        }
        let before_login = {
          noSingleLogin: data.noSingleLogin, //单处登录
          editPwd: data.editPwd, // 修改密码
          showInfo: data.showInfo, //完善资料
          userInfoConfim: data.userInfoConfim, //用户信息防遗忘
          secAuth: data.secAuth, //是否需要二次认证
        };
        sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(before_login));

        let obj = {
          username: data.username,
          displayName: data.displayName,
          email: data.email,
          mobile: data.mobile,
        };
        this.$store.commit("auth/setUser", obj);
        this.$store.commit("auth/setToken", data.token);
        this.$store.commit("auth/setSessionToken", data.token);
        this.$store.commit("auth/setSessionUser", obj);
        if (data.remeberMe) {
          const cookiePayload = {
            user: {
              username: data.username,
              displayName: data.displayName,
              email: data.email,
              mobile: data.mobile,
            },
            token: data.token,
          };
          this.$cookies.set("REMEMBER_ME", cookiePayload, "7d");
        }
        if (typeof this.setLoginCookies === "function") {
          this.setLoginCookies(data.token, obj);
        }

        if (
          data.unusualAddressLoginPrompt &&
          data.unusualAddressLoginPrompt != ""
        ) {
          this.$confirm({
            title: "温馨提示",
            content: data.unusualAddressLoginPrompt,
            onOk() {
              that.jumpComputed();
            },
            onCancel() {
              that.$store.dispatch("auth/loginOut");
            },
          });
        } else {
          this.jumpComputed();
        }
      } else {
        this.loginFailCount = data.loginFailCount;
        toast(loginErrorText(code, message));
        // 如果没成功则重新生成新的验证码
        this.getValidMask();
      }
    },
    // 忘记密码
    handleForget() {
      this.$router.push({ path: "mforget" });
    },
    // 账号激活
    handleActivate() {
      this.$router.push({ path: "mactivate" });
    },
    // 更多登录
    handleMore() {
      this.$router.push({ path: "/mloginList" });
    },
    // 关闭滑块验证
    slideClose() {
      this.verifyVisible = false;
    },
    // 滑块验证成功
    slideSuccess() {
      this.verifyVisible = false;
      this.handleLogin();
    },
    // author: wzh, date: 2023-01-06, for: 语言切换
    languageChange(action) {
      this.language = action.text;
      this.$i18n.locale = action.value;
      localStorage.setItem("language", JSON.stringify(action));
      // this.$bus.emit("change_lang");
    },
  },
};
</script>

<style lang="scss" scoped>
.login_main::v-deep {
  min-height: 100vh;
  background-color: #fff;
  padding-bottom: 30px;

  .l_top {
    padding: 60px 0 40px;
    background-image: url("~@/assets/mAssets/images/login/top_bg.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;

    .l_t_select {
      position: absolute;
      top: 20px;
      right: 20px;
    }

    .l_t_banner {
      min-height: 50px;
      margin: 3px 0 16px;

      & > img {
        display: block;
        max-width: 50%;
        max-height: 50px;
        margin: 0 auto;
      }
    }

    .l_t_title {
      text-align: center;
      font-size: 24px;
    }
  }

  .l_m_body {
    padding: 0 32px;

    .l_m_title {
      text-align: center;
      color: #333;
      font-size: 24px;
      margin: 32px 0;
    }

    .l_m_form {
      .l_m_remember {
        margin: 8px 0 16px;
        font-size: 14px;
        color: #666;
      }

      .van-cell {
        padding: 0;
        margin-bottom: 20px;

        &::after {
          display: none;
        }
      }

      .van-field__control {
        border: 1px solid #ededed;
        border-radius: 22px;
        height: 44px;
        padding-left: 50px;
      }

      .l_m_code_box .van-field__button {
        display: flex;
        align-items: center;
      }

      .l_m_username .van-field__control {
        background: url("~@/assets/mAssets/images/login/bg_user.png") no-repeat
          20px center / 14px;
      }

      .l_m_password .van-field__control {
        background: url("~@/assets/mAssets/images/login/bg_password.png")
          no-repeat 20px center / 14px;
      }

      .l_m_code {
        width: 28vw;
        height: 36px;
      }
    }

    .l_m_forget {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #3c95ff;
      margin: 10px 0 28px;
      padding: 0 20px;
    }

    .van-divider {
      margin: 90px 0 24px;
    }

    .l_m_other {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & > img {
        width: 30px;
        height: 30px;
      }
    }

    .l_m_more {
      font-size: 12px;
      color: #3c95ff;
      text-align: center;
      margin-top: 30px;
    }
  }
}
</style>
